// Get the modal
var routeModal = document.getElementById('route-info');

// Get the button that opens the modal
var routeModalTrigger = document.querySelectorAll('.route-modal-trigger');

// When the user clicks on the button, open the modal
routeModalTrigger.forEach((e) => {
  //console.log('clicked route');
  e.onclick = function () {
    routeModal.style.display = 'block';
    //load the images on open
    var $lazyRouteImage = document.querySelectorAll('.lazy-route');
    for (let $image of $lazyRouteImage) {
      let notLoaded = $image.classList.contains('lazy-route');
      if (notLoaded) {
        var srcPath = $image.dataset.src;
        $image.src = srcPath;
        setTimeout(function () {
          $image.removeAttribute('data-src');
          $image.classList.remove('lazy-route');
        }, 10);
      }
    }
  };
});

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == routeModal) {
    routeModal.style.display = 'none';
  }
};
